import { useTranslation } from 'react-i18next';

import {
  PlainTextIcon,
  RichMessageIcon,
  ImageTypeIcon,
  ImageVideoTypeIcon,
  ButtonTypeIcon,
  IconType,
} from '@anyx/shared-icons';

import { LineMessageBlockType } from '../types';

export interface BlockTitleProps {
  withIcon?: boolean;
  className?: string;
  type: LineMessageBlockType;
}

export const BlockTitleIcons: Record<LineMessageBlockType, IconType> = {
  PLAIN_TEXT: PlainTextIcon,
  RICH: RichMessageIcon,
  IMAGES: ImageTypeIcon,
  IMAGE_VIDEO: ImageVideoTypeIcon,
  BUTTON: ButtonTypeIcon,
};

export const BlockTitle = ({ type, withIcon = true, className = '' }: BlockTitleProps) => {
  const { t } = useTranslation('crm');
  const Icon = withIcon ? BlockTitleIcons[type] : null;

  return (
    <div className={`flex items-center gap-x-1 ${className}`}>
      {Icon && <Icon />}
      <span>
        {t('crm.lineMessageForm.blockTitle', {
          type,
        })}
      </span>
    </div>
  );
};
